export default "__VITE_ASSET__4db1402a__"